import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "../../Assets/styles/customPhoneSelect.css";
import "react-phone-number-input/style.css";
import { colors } from "../../Assets/styles/colors";
import { useTranslate } from '@tolgee/react';
import { useConversationService } from "../../Context/ConversationsContext";

import { useAuthService } from "../../Context/AuthContext";
import GroupSelectedMembers from "./GroupSelectedMembers";

import AddMembers from "../NewGroup/AddMembers";

import PrimaryButton from "../GenericComponents/PrimaryButton";
import {
  ADD_MEMBERS,
  NEW_CONTACT,
  SELECTED_MEMBERS,
} from "../../Constants/constantValues";
import AddNewChatContact from "../Contacts/AddNewContact";
import { useNotify } from "../../Helpers/Notifications";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";

const GroupDetailsView = ({
  groupData,
  setConversations,
  setSelectedConversation,
  contacts,
  setLoading,
  loadContacts,
  handleInviteContact,
}) => {
  const {
    removeGroupMember,
    addGroupMember,
    updateGroup,
    makeGroupAdmin,
    removeGroupAdmin,

  } = useConversationService();
  const { notifySuccess, notifyError, notifyInfo } = useNotify();
  const { setShowGroupChatDetails } = useGenericComponentsStateService();
  const initialValues = {
    groupName: groupData?.group?.name,
  };

  const { user } = useAuthService();

  const [phone, setPhone] = useState("");
  const [inputValues, setInputValues] = useState(initialValues);
  const profileAvatarRef = useRef();
  const [previewAvatar, setPreviewAvatar] = useState();
  const [avatar, setAvatar] = useState();
  const [selectedContacts, setSelectedContacs] = useState([]);
  const [initialContacts, seInitialContacts] = useState([]);
  const [infoChanged, setInfoChanged] = useState(false);
  const [option, setOption] = useState(SELECTED_MEMBERS);
  const { t } = useTranslate();

  const handleInputChange = (e) => {
    const { name, value } = e.currentTarget;
    setInputValues({
      ...inputValues,
      [name]: value,
    });
  };

  const handleOpenAvatar = () => {
    profileAvatarRef.current.click();
  };

  const handleAvatarChange = (e) => {
    setAvatar(e.target.files[0]);
    setPreviewAvatar(URL.createObjectURL(e.target.files[0]));
  };

  const handleAddMember = (member, onSucces) => {
    addGroupMember(
      groupData.group.id,
      [member.id],
      function (response) {
        let res = response.data.conversation;
        setPhone(null);
        setConversations((prev) => {
          let mapped = prev.map((item) => {
            if (item.id === res.id) {
              return res;
            } else {
              return item;
            }
          });
          return mapped;
        });
        setSelectedConversation(res);
        if (onSucces) {
          onSucces();
        }
      },
      function (error) {
        notifyError(`${t('general.something_wrong')}`);
        console.log(error);
      }
    );
  };

  const handleRemoveMember = (member) => {
    removeGroupMember(
      groupData.group.id,
      [member.id],
      function (response) {
        let res = response.data.conversation;
        if (member.id === user.id) {
          setConversations((prev) => {
            let mapped = prev.filter((item) => item.id !== res.id);
            return mapped;
          });
          setSelectedConversation(null);
          setShowGroupChatDetails(false)
        } else {
          setConversations((prev) => {
            let mapped = prev.map((item) => {
              if (item.id === res.id) {
                return res;
              } else {
                return item;
              }
            });
            return mapped;
          });

          setSelectedConversation(res);
        }
      },
      function (error) {
        notifyError(`${t('general.something_wrong')}`);
        console.log(error);
      }
    );
  };

  const handleUpdateGroup = () => {
    var objData = new FormData();

    objData.append("id", groupData.group.id);
    objData.append("name", inputValues.groupName);

    if (avatar) {
      objData.append("image", avatar);
    }

    updateGroup(
      objData,
      function (response) {
        let resp = response.data.conversation;
        setConversations((prev) => {
          let mapped = prev.map((item) => {
            if (item.id === resp.id) {
              return resp;
            } else {
              return item;
            }
          });
          return mapped;
        });
        setSelectedConversation(resp);
      },
      function (error) {
        notifyError(`${t('general.something_wrong')}`);
        console.log(error);
      }
    );
  };

  const handleMakeAdmin = (member) => {
    setLoading(true);
    makeGroupAdmin(
      groupData.group.id,
      [member.id],
      (response) => {
        let res = response.data.conversation;

        setConversations((prev) => {
          let mapped = prev.map((item) => {
            if (item.id === res.id) {
              return res;
            } else {
              return item;
            }
          });
          return mapped;
        });
        setLoading(false);
        setSelectedConversation(res);
      },
      (error) => {
        setLoading(false);
        notifyError(`${t('general.something_wrong')}`);
        console.log(error);
      }
    );
  };

  const handleRevokeAdmin = (member) => {
    setLoading(true);
    removeGroupAdmin(
      groupData.group.id,
      [member.id],
      (response) => {
        let res = response.data.conversation;

        setConversations((prev) => {
          let mapped = prev.map((item) => {
            if (item.id === res.id) {
              return res;
            } else {
              return item;
            }
          });
          return mapped;
        });
        setLoading(false);
        setSelectedConversation(res);
      },
      (error) => {
        setLoading(false);
        notifyError(`${t('general.something_wrong')}`);
        console.log(error);
      }
    );
  };

  const checkChanges = () => {
    if (
      inputValues.groupName != groupData.group.name ||
      previewAvatar != groupData.group.image
    ) {
      setInfoChanged(true);
    } else {
      setInfoChanged(false);
    }
  };

  const displaySortedParticipants = (user_list) => {
    let newUserList = user_list;
    let sortedParticipants = newUserList.sort((a, b) =>
      a.name > b.name ? 1 : -1
    );
    return sortedParticipants;
  };

  const handleBackBtn = () => {
    setOption(SELECTED_MEMBERS);
    setSelectedContacs(initialContacts);
  };

  const handleSaveBtn = () => {
    const newToAdd = selectedContacts.filter(
      (selected) => !initialContacts.some((remove) => remove.id == selected.id)
    );

    for (let index = 1; index <= newToAdd.length; index++) {
      if (newToAdd.length > 1) {
        if (index == newToAdd.length) {
          notifySuccess(t('new_chat.members_added'));
          setOption(SELECTED_MEMBERS);
          return;
        }
        handleAddMember(newToAdd[index - 1], function () {
          handleAddMember(newToAdd[index]);
        });
      } else {
        handleAddMember(newToAdd[index - 1], function () {
          notifySuccess(t('new_chat.members_added'));
          setOption(SELECTED_MEMBERS);
        });

        return;
      }
    }
  };

  const handleSelectNewContact = (contact) => {
    let foundInSelected = selectedContacts.find(
      (item) => item.id === contact.id
    );
    let foundInInitial = initialContacts.find((item) => item.id === contact.id);

    if (foundInSelected) {
      if (foundInInitial) {
        return;
      }
      let filtered = selectedContacts.filter((item) => item.id !== contact.id);
      setSelectedContacs(filtered);
    } else {
      setSelectedContacs([...selectedContacts, contact]);
    }
  };

  const handleCloseAddNewContact = (item) => {
    setOption(ADD_MEMBERS);
  };

  useEffect(() => {
    checkChanges();
  }, [inputValues, previewAvatar]);

  useEffect(() => {
    setInputValues(initialValues);
    let sortedParticipants = displaySortedParticipants(
      groupData.other_participants
    );
    seInitialContacts(sortedParticipants);
    setSelectedContacs(sortedParticipants);
    setPreviewAvatar(groupData.group.image);
  }, [groupData, groupData.other_participants?.length]);

  return (
    <AddNewGroupContainer>
      {option === ADD_MEMBERS && (
        <Wrapper>
          <AddMembers
            contacts={contacts}
            selectedContacts={selectedContacts}
            setSelectedContacs={setSelectedContacs}
            initialContacts={initialContacts}
            setOption={setOption}
            groupDetailsSide
            handleSelectContact={handleSelectNewContact}
            handleInviteContact={handleInviteContact}
            handleBackBtn={handleBackBtn}
            handleSaveBtn={handleSaveBtn}
          />
        </Wrapper>
      )}

      {option === SELECTED_MEMBERS && (
        <GroupSelectedMembers
          inputValues={inputValues}
          handleAvatarChange={handleAvatarChange}
          setOption={setOption}
          previewAvatar={previewAvatar}
          handleInputChange={handleInputChange}
          handleOpenAvatar={handleOpenAvatar}
          profileAvatarRef={profileAvatarRef}
          groupData={groupData}
          handleRemoveMember={handleRemoveMember}
          selectedContacts={selectedContacts}
          initialContacts={initialContacts}
          handleMakeAdmin={handleMakeAdmin}
          handleRevokeAdmin={handleRevokeAdmin}
        />
      )}

      {option === NEW_CONTACT && (
        <Wrapper>
          <AddNewChatContact
            loadContacts={loadContacts}
            closeAction={handleCloseAddNewContact}
          />
        </Wrapper>
      )}
      {infoChanged && (
        <Group>
          <PrimaryButton
            style={{ padding: "16px" }}
            onClick={() => handleUpdateGroup()}
            text={t('general.save')}
          />
        </Group>
      )}
    </AddNewGroupContainer>
  );
};

export default GroupDetailsView;

const AddNewGroupContainer = styled.div`
  background: ${({ theme }) => theme.menu.background};
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 25px;
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: auto;

`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Wrapper = styled.div`
  position: absolute;
  height: 100%;
  top: 0;
  overflow: auto;
  width: 100%;
  left: 0;
  background: ${colors.newChatModalBg};

  gap: 25px;
  display: flex;
  flex-direction: column;
`;
